import React from 'react'
import styles from './index.module.scss'
import { outLoginApi } from '@/api'
import defaultSetting from '@/setting'
const avatar = require('@/assets/images/avatar.png')

function outLogin({userName, headImgUrl, titleColor}) {
    // 退出登录
    const doOut = () => {
        outLoginApi().then(() => {
            window.location.href = '/'
        })
    }
    return (
        <div className={styles.outLogin}>
            <div className={`user-info lx-flex-row lx-pointer`} style={{color: titleColor}}>
                <div className="user-avatar lx-fz0 lx-hidden">
                    <img className="avatar lx-h100" src={headImgUrl || avatar} alt="avatar" />
                </div>
                <a href={`/${defaultSetting.suiteKey}/pb/account.html#/`} className="user-name lx-fz14">你好，
                    <span className="name">{userName}</span>
                </a>
                <div className="user-outlogin" onClick={doOut}>
                    <span className="lx-fz14">退出</span>
                </div>
            </div>
        </div>
    )
}
export default outLogin;